import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { client } from '@utils/client'
// import { useHistory } from 'react-router-dom'
import Modal from '@components/Modal'
import { wellKidzClubECoupon } from './List'
import Text from '@components/Text'
import { Alert, message } from 'antd'
import FormComponent from './Form'

// import { PlusCircleOutlined } from '@ant-design/icons'

const Create = (props) => {
  const { open, setOpen, reload } = props
  const defaultValue = {
    conditions: '',
    conditionsEng: '',
  }
  const { t } = useLocalization()

  const [errorMessage, setErrorMessage] = useState()
  // const history = useHistory()
  // const params = useParams()

  const handleSubmit = async (data) => {
    const convertData = { ...data }
    convertData.startAt = data.startAt.format('YYYY-MM-DD')
    convertData.expiredAt = data.expiredAt.format('YYYY-MM-DD')

    if (convertData.typePermissionCoupon === 'UnLimit') {
      convertData.typePermissionCouponLimit = 0
    }

    try {
      if (convertData.typePermissionCouponLimit < 0) {
        setErrorMessage('จำนวนสิทธิ์ที่ถูกจำกัดต้องมากกว่า 0 สิทธิ์')
        throw new Error('จำนวนสิทธิ์ที่ถูกจำกัดต้องมากกว่า 0 สิทธิ์')
      }

      await client.post(`/coupons`, convertData)
      message.success('สำเร็จ')
      reload()
      setOpen(false)
    } catch (e) {
      if (
        e.response &&
        e.response.data &&
        e.response.data.message ===
          'Expiration date must be after the start date'
      ) {
        setErrorMessage('วันหมดอายุต้องอยู่หลังวันที่เริ่มต้น')
      } else if (
        e.response &&
        e.response.data &&
        e.response.data.message ===
          `Cannot update typePermissionCouponLimit: total usage count exceeds the limit`
      ) {
        setErrorMessage('จำนวนสิทธิ์ที่ถูกจำกัดต้องมากกว่า 0 สิทธิ์')
      } else if (e.response) {
        setErrorMessage(e.response.data.message)
      } else {
        setErrorMessage(e.message)
      }
      message.error('ไม่สำเร็จ')
    }
  }
  const reset = () => {
    setErrorMessage(undefined)
  }

  /**
   * @type {{
   * header: React.CSSProperties
   * bodyModalStyle: React.CSSProperties
   * }}
   */

  const style = {
    header: { fontWeight: '700' },
    bodyModalStyle: {
      display: 'flex',
      flexDirection: 'column',
      padding: 16,
      overflowY: 'hidden',
      gap: 16,
      maxHeight: 850,
    },
  }

  const formMemo = useMemo(() => {
    return (
      <FormComponent
        handleSubmit={handleSubmit}
        defaultValues={defaultValue}
        doStatus="create"
      />
    )
  }, [])
  return (
    <>
      <Modal
        centered={false}
        open={open}
        onCancel={() => setOpen(false)}
        closable={true}
        maskClosable={false}
        // footer={null}
        width={800}
        style={{ top: 20 }}
        bodyStyle={style.bodyModalStyle}
      >
        <Text level={1} style={style.header}>
          {t(`${wellKidzClubECoupon}.addECoupon`)}
        </Text>
        {errorMessage && (
          <Alert
            message={errorMessage}
            type="error"
            showIcon
            closable
            onClose={reset}
          />
        )}
        {formMemo}
      </Modal>
    </>
  )
}

Create.propTypes = {
  reload: PropTypes.func,
  setOpen: PropTypes.func,
  open: PropTypes.bool,
}

export default Create
